import { Button, Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import approveAll from "../icons/approveAll.json";
import { useTranslation } from "react-i18next";
import Select, { MultiValue } from "react-select";
import { themeSelect } from "./Select2";
export const BlockManageModal = ({
  numberOfProducts,
  allBlocks,
  show,
  setShow,
  handleApprove,
  handleSelectBlock,
  handleClose,
}: any) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={() => handleClose()} size="sm" centered>
      <Modal.Body className="d-flex align-items-center flex-column">
        <h5>{t(`manage.add_blocks`)}</h5>
        <p>
          {t(`manage.number_of_selected_products`)}{" "}
          <span className="text-success">{numberOfProducts ?? 0}</span>
        </p>
        <div className="row w-100 blocks-manage">
          <label htmlFor="blocks">{t("products.blocks")}</label>
          <Select
            className="react-select-field min-height-150 "
            theme={themeSelect}
            options={allBlocks?.map((value: { name: string; id: number }) => ({
              label: value?.name,
              value: value?.id,
            }))}
            isMulti
            onChange={(e) => {
              handleSelectBlock(
                e as MultiValue<{
                  label: string;
                  value: number;
                  isAdd: boolean;
                }>
              );
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex align-items-center justify-content-center">
        <Button variant="light" size="sm" onClick={handleClose}>
          {t(`modals.close`)}
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            handleClose();
            handleApprove();
          }}
        >
          {t(`global.add`)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
